import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from "./utils/auth";

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/','/goods', '/search','/celebrity','/article','/orchid','/shop','/friends']; // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    NProgress.start();
    const hasToken = getToken();
    if (hasToken) {
        const hasRole = store.getters.userId;
        if(hasRole){
            next()
        }else {
            store.dispatch('getMeInfoData')
            next()
        }
    } else {
        if(to.meta.requireAuth){
            next(false)
            // other pages that do not have permission to access are redirected to the login page.
            store.commit('changeLoginShow',true);
        }else {
            next()
        }
        NProgress.done();
    }
});
router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})